<template>
  <div class="zn-product-container">
    <div class="product-content-container">
      <div class="product-introduce">
        <div class="introduce-left">
          <div class="name wow fadeInLeft" data-wow-delay="0.1s">
            <span>众诺CRM</span>
          </div>
          <div class="introduce wow fadeInLeft" data-wow-delay="0.2s">
            <span
              >专为妇产医院快速销售而打造的客户关系管理系统，全流程解决客户管理需求。CRM客户关系管理系统是集客户管理、销售管理、项目管理、服务管理等的一体化系统，提供私有化部署且支持个性化定制开发。</span
            >
          </div>
          <div class="experience-btn wave wow fadeInLeft" data-wow-delay="0.3s">
            <span>获取体验资格</span>
          </div>
        </div>
        <div class="introduce-right">
          <div class="product-img wow fadeInLeft" data-wow-delay="0.3s">
            <img src="@/assets/images/zn-product.png" alt="" />
          </div>
          <div class="product-bg">
            <img
              class="wow fadeInRight"
              data-wow-delay="0.1s"
              src="@/assets/images/product-bg-1.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="product-advanage">
        <div class="title wow fadeInUp">
          <span>产品优势</span>
        </div>
        <div class="advanage-cards-container">
          <div
            class="advanage-card-container"
            v-for="(item, index) in advanageData"
            :key="index"
          >
            <div
              class="advanage-card wow flipInX"
              :data-wow-delay="`${(index + 1) / 10}s`"
            >
              <img :src="item.imgUrl" alt="" />
            </div>
            <span
              class="wow fadeInUp"
              :data-wow-delay="`${(index + 1) / 10}s`"
              >{{ item.txt }}</span
            >
          </div>
        </div>
      </div>
      <div class="product-function">
        <div class="title wow fadeInUp">
          <span>产品功能</span>
        </div>
        <div class="product-function-cards-container">
          <div class="product-function-card-container">
            <div
              class="product-function-card-img wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <img src="@/assets/images/product-1.png" alt="" />
            </div>
            <div
              class="product-function-card-txt wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-01.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[0].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[0].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-txt wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-02.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[1].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[1].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
            <div
              class="product-function-card-img wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <img src="@/assets/images/product-2.png" alt="" />
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="visit-img-container wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <img class="pic1" src="@/assets/images/product-3.png" alt="" />
              <img class="pic2" src="@/assets/images/product-4.png" alt="" />
              <img class="pic3" src="@/assets/images/product-5.png" alt="" />
            </div>
            <div
              class="product-function-card-txt wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-03.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[2].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[2].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-txt wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-04.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[3].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[3].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
            <div
              class="product-function-card-img wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <img src="@/assets/images/product-6.png" alt="" />
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="chart-img-container wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <img class="pic1" src="@/assets/images/product-7.png" alt="" />
              <img class="pic2" src="@/assets/images/product-8.png" alt="" />
            </div>
            <div
              class="product-function-card-txt wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-05.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[4].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[4].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-txt wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-06.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[5].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[5].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
            <div
              class="product-function-card-img wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <img src="@/assets/images/product-9.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      advanageData: [
        {
          imgUrl: require("@/assets/images/ad-1.png"),
          txt: "多业务平台整合",
        },
        {
          imgUrl: require("@/assets/images/ad-2.png"),
          txt: "医院高度定制",
        },
        {
          imgUrl: require("@/assets/images/ad-3.png"),
          txt: "配套引流小程序",
        },
        {
          imgUrl: require("@/assets/images/ad-4.png"),
          txt: "专业运营工具",
        },
        {
          imgUrl: require("@/assets/images/ad-5.png"),
          txt: "数据加密留存",
        },
      ],
      functionData: [
        {
          id: 1,
          title: "客户数据统计可视化",
          desc: [
            "客户数据：可视化客户数据统计，追踪客户全流程数据",
            "待办事项：对客户进行快速回访、预约、签到等操作",
            "客户图表：多维度、全流程对比分析客户增量数据",
            "预约余量：预约余量日历表，方便快捷安排客户预约",
          ],
        },
        {
          id: 2,
          title: "客户资源化管理",
          desc: [
            "针对每个客户进行多记录的资源化管理，从咨询、预约、到诊，保留每个客户每个阶段的数据。并可对单独的资源记录进行追踪。使每条记录可溯源",
          ],
        },
        {
          id: 3,
          title: "快速预约和回访",
          desc: [
            "客户回访：记录回访信息，保留多次回访记录",
            "快速预约：登记预约信息，并及时进行预约来访时间提醒",
            "线上短信：针对客户发送单独定制短信或群发短信",
          ],
        },
        {
          id: 4,
          title: "客户消费统计",
          desc: [
            "产康报表：针对产康客户的项目销售数据多维度统计",
            "产检报表：针对产检客户的套餐销售数据多维度统计",
          ],
        },
        {
          id: 5,
          title: "客户数据统计报表",
          desc: [
            "更加全面的客户数据统计，分析客户画像，创建客户数据模型，进行精准全面的业务分析。根据统计数据，还可以进行广告投放分析，获取更多的客户资源",
          ],
        },
        {
          id: 6,
          title: "服务管理",
          desc: [
            "项目管理：构建完整的医院项目体系",
            "配额管理：自定义来源、工具、病种等配置项",
            "标签管理：为每个客户提供自定义个性化标签",
            "配额管理：自定义项目的预约余量数据",
            "短信管理：创建所有情境下的短信提醒工具",
          ],
        },
      ],
    };
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
  },
};
</script>

<style lang="scss" scoped>
.zn-product-container {
  .product-content-container {
    .product-introduce {
      width: 100%;
      height: 360px;
      background: #f9fafc;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10%;
      .introduce-left {
        flex: 1;
        .name {
          font-family: PingFangSC-Semibold;
          font-size: 34px;
          color: #222222;
        }
        .introduce {
          //   width: 500px;
          padding-right: 10%;
          margin: 20px 0 30px 0;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #6a717c;
          letter-spacing: 0;
        }
        .experience-btn {
          width: 136px;
          height: 40px;
          background-image: linear-gradient(270deg, #119dfd 0%, #0764fb 100%);
          border-radius: 20px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ffffff;
          @include btn;
        }
      }
      .introduce-right {
        flex: 1;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .product-img {
          z-index: 2;
          position: absolute;
          img {
            height: 260px;
          }
        }
        .product-bg {
          position: absolute;
          transform: translate(130px, -10px);
          img {
            height: 300px;
          }
        }
      }
    }
    .product-advanage {
      display: flex;
      // justify-content: center;
      flex-direction: column;
      align-items: center;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #222222;
        margin: 70px 0 50px 0;
      }
      .advanage-cards-container {
        width: 100%;
        padding: 0 15%;
        display: flex;
        justify-content: space-between;
        .advanage-card-container {
          .advanage-card {
            width: 120px;
            height: 120px;
            img {
              width: 120px;
              height: 120px;
              margin-bottom: 12px;
            }
          }
          span {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #1e1f28;
          }
        }
      }
    }
    .product-function {
      display: flex;
      // justify-content: center;
      flex-direction: column;
      align-items: center;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #222222;
        margin: 100px 0 50px 0;
      }
      .product-function-cards-container {
        width: 100%;
        //   padding: 0 10%;
        .product-function-card-container {
          padding: 0 10%;
          display: flex;
          align-items: center;
          height: 600px;
          background-image: linear-gradient(180deg, #ffffff 0%, #f9fafc 100%);
          .product-function-card-img {
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            // justify-content: center;
            img {
              width: 600px;
            }
          }
          .visit-img-container {
            flex: 1;
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            .pic1 {
              height: 400px;
              position: absolute;
            }
            .pic2 {
              height: 200px;
              position: absolute;
              transform: translate(-60px, 140px);
            }
            .pic3 {
              height: 200px;
              position: absolute;
              transform: translate(230px, -20px);
            }
          }
          .chart-img-container {
            flex: 1;
            position: relative;
            height: 100%;
            display: flex;
            align-items: center;
            .pic1 {
              height: 350px;
              position: absolute;
            }
            .pic2 {
              height: 140px;
              position: absolute;
              transform: translate(300px, 150px);
            }
          }
          .product-function-card-txt {
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .index-container {
              width: 400px;
              img {
                width: 104px;
                height: 74px;
              }
            }
            .function-title {
              position: relative;
              font-family: PingFangSC-Semibold;
              font-size: 30px;
              color: #1e1f28;
              margin-bottom: 20px;
              width: 400px;
              &::after {
                content: "";
                display: block;
                width: 60px;
                height: 4px;
                position: absolute;
                bottom: -20px;
                background-image: linear-gradient(
                  269deg,
                  #119dfd 0%,
                  #0764fb 100%
                );
              }
            }
            .function-desc {
              margin-top: 37px;
              width: 400px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #404040;
              line-height: 28px;
              span {
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productCenter/components/znProduct.vue